import addressBookRoutes from './addressBook.routes';
import authRoutes from './auth.routes';
import consigmentsRoutes from './consigments.routes';
import customerPricesRoutes from './customerPrices.routes';
import customersRoutes from './customers.routes';
import getPriceRoutes from './getPrice.routes';
import invoiceModuleRoutes from './invoiceModule.routes';
import pricePackagesRoutes from './pricePackages.routes';
import findShipmentRoutes from './findShipment.routes';
import productsRoutes from './products.routes';
import profileRoutes from './profile.routes';
import providersRoutes from './providers.routes';
import barcodePoolRoutes from './barcodePool.routes';
import rolesRoutes from './roles.routes';
import adminSpecialOfferRoutes from './adminSpecialOffer.routes';
import departmentRoutes from './department.routes';
import postalCodeRoutes from './postalCode.routes';
import webHooksRoutes from './webHooks.routes';
import TaxOfficesRoutes from './taxOffices.routes';
import taxesRoutes from './taxes.routes';
import pickupsRoutes from './pickup.routes';
import priceManagementRoutes from './priceManagement.routes';
import exportListRoutes from './exportList.routes';
import reportRoutes from './reports.routes';
import paymentRoutes from './payment.routes';
import integrationsRoutes from './integrations.routes';

export default [
  ...getPriceRoutes,
  ...providersRoutes,
  ...barcodePoolRoutes,
  ...consigmentsRoutes,
  ...findShipmentRoutes,
  ...adminSpecialOfferRoutes,
  ...addressBookRoutes,
  ...customersRoutes,
  ...customerPricesRoutes,
  ...productsRoutes,
  ...pricePackagesRoutes,
  ...invoiceModuleRoutes,
  ...webHooksRoutes,
  ...rolesRoutes,
  ...profileRoutes,
  ...authRoutes,
  ...departmentRoutes,
  ...postalCodeRoutes,
  ...paymentRoutes,
  ...TaxOfficesRoutes,
  ...taxesRoutes,
  ...pickupsRoutes,
  ...priceManagementRoutes,
  ...integrationsRoutes,
  ...reportRoutes,
  ...exportListRoutes
];
